<template>
    <LoadingComponent :props="loading" />
    <div id="sms" class="db-tab-div active">
        <div class="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 mb-5 bg-white border rounded-md p-3">
            <button @click="selectActive(index)"
                class="db-tab-sub-btn w-full flex items-center gap-3 h-10 px-4 rounded-lg transition bg-white hover:text-primary hover:bg-primary/5"
                :data-tab="'#' + smsGateway.slug" v-for="(smsGateway, index) in gatewaysData.slice(0, 3)" :key="smsGateway.slug"
                :class="index === selectIndex ? 'active' : ''">
                <span class="capitalize whitespace-nowrap text-[15px]">
                    {{ smsGateway.name }}
                </span>
            </button>

            <div v-if="gatewaysData.length > 3" class="dropdown-group w-full">
                <button @click.prevent="tabMore = !tabMore"
                    class="dropdown-btn w-full flex items-center gap-3 h-10 px-4 rounded-lg transition bg-white hover:text-primary hover:bg-primary/5">
                    <i :class="{ 'rotate-180': tabMore }" 
                        class="fa-solid fa-circle-chevron-down text-sm transition-all duration-500"></i>
                    <span class="capitalize whitespace-nowrap text-[15px]"> {{ $t('label.more_gateway') }}</span>
                </button>
                <div class="w-full dropdown-list absolute top-[42px] right-0 z-30 p-2 rounded-md bg-white shadow-lg">
                    <button @click="selectActive(index + 3)"
                        class="w-full flex items-center h-8 px-2 rounded-lg transition bg-white hover:text-primary hover:bg-primary/5"
                        :data-tab="'#' + smsGateway.slug"
                        v-for="(smsGateway, index) in gatewaysData.slice(3, gatewaysData.length)" :key="smsGateway.slug"
                        :class="index + 3 === selectIndex ? 'active' : ''">
                        {{ smsGateway.name }}
                    </button>
                </div>
            </div>
        </div>
        <div :id="smsGateway.slug" class="db-card db-tab-sub-div" v-for="(smsGateway, index) in gatewaysData"
            :key="smsGateway.slug" :class="{ 'active': index === selectIndex, 'on-update': onUpdateActive && index === selectIndex }">
            <div class="db-card-header items-center justify-between gap-4">
                <h3 class="db-card-title">{{ smsGateway.name }}</h3>
            
            <div class="flex items-center gap-2">
                <button
                    type="button"
                    class="db-btn h-9 py-2 px-3 text-white bg-primary ml-3"
                    @click="refreshFromServer"
                    :disabled="isRefreshingView"
                    :class="{ 'disabled:opacity-50 disabled:bg-gray': isRefreshingView }"
                >
                    <template v-if="isRefreshingView">
                        <svg class="inline-block animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                            <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                            <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                        </svg>
                    </template>
                    <template v-else>
                        <i class="fa-solid fa-arrows-rotate"></i>
                    </template>
                </button>
            </div></div>
            <div class="db-card-body">
                <form @submit.prevent="save(index)" :id="'formElem' + index" class="w-full d-block">
                    <div class="form-row">
                        <input type="hidden" :value="smsGateway.slug" name="sms_type">

                        <div class="form-col-12 sm:form-col-6" v-for="smsGatewayOption in smsGateway.options"
                            :key="smsGatewayOption.option">
                            <label :for="smsGatewayOption.option" class="db-field-title">
                                {{ $t("label." + smsGatewayOption.option) }}
                            </label>
                            <input v-if="smsGatewayOption.type === enums.inputTypeEnum.TEXT" type="text"
                                v-model="smsGatewayOption.value"
                                v-bind:class="errors[smsGatewayOption.option] ? 'invalid' : ''"
                                :name="smsGatewayOption.option" :id="smsGatewayOption.option" class="db-field-control" />

                            <template v-else>
                                <vue-select
                                    :key="smsGatewayOption.option"
                                    class="db-field-control f-b-custom-select"
                                    v-model="smsGatewayOption.value"
                                    :options="getSelectOptions(smsGatewayOption)"
                                    label-by="name"
                                    value-by="id"
                                    :closeOnSelect="true"
                                    :searchable="true"
                                    :clearOnClose="true"
                                />
                                <input type="hidden" :name="smsGatewayOption.option" :value="smsGatewayOption.value" />
                            </template>

                            <small class="db-field-alert" v-if="errors[smsGatewayOption.option]">{{
                                errors[smsGatewayOption.option][0]
                            }}</small>
                        </div>
                        <div class="form-col-12 border-t pt-5 mt-3">
                            <button type="submit" class="db-btn text-white bg-primary" :disabled="isSaving">
                                <template v-if="isSaving">
                                    <svg class="inline-block mr-1 animate-spin" viewBox="0 0 24 24" width="14" height="14" aria-hidden="true">
                                        <circle cx="12" cy="12" r="10" fill="none" stroke="currentColor" stroke-width="3" opacity="0.25"></circle>
                                        <path d="M22 12a10 10 0 0 1-10 10" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"></path>
                                    </svg>
                                    <span>{{ $t('button.updating') }}</span>
                                </template>
                                <template v-else>
                                    <i class="lab lab-fill-save"></i>
                                    <span>{{ $t("button.save") }}</span>
                                </template>
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import LoadingComponent from "../../components/LoadingComponent";
import appService from "../../../../services/appService";
import alertService from "../../../../services/alertService";
import inputTypeEnum from "../../../../enums/modules/inputTypeEnum";

export default {
    name: "SmsGatewayComponent",
    components: { LoadingComponent },
    data() {
        return {
            isRefreshingView: false,
            loading: {
                isActive: false,
            },
            tabMore: false,
            search: {
                paginate: 0,
                order_column: "id",
                order_type: "asc"
            },
            selectIndex: 0,
            enums: {
                inputTypeEnum: inputTypeEnum
            },
            isSaving: false,
            onUpdateActive: false,
            errors: {},
            gatewaysData: []
        };
    },
    computed: {
        smsGateways: function () {
            return this.$store.getters["smsGateway/lists"];
        },
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        fetchData: function (showOverlay = true) {
            if (showOverlay) {
                this.loading.isActive = true;
            }
            return this.$store
                .dispatch("smsGateway/lists", this.search)
                .then((res) => {
                    const rawData = JSON.parse(JSON.stringify(this.smsGateways));
                    if (Array.isArray(rawData)) {
                        rawData.forEach(gateway => {
                            if (Array.isArray(gateway.options)) {
                                gateway.options.forEach(opt => {
                                    if (opt.activities) {
                                        let activitiesObj = typeof opt.activities === 'string' ? JSON.parse(opt.activities) : opt.activities;
                                        const keys = Object.keys(activitiesObj);
                                        const hasNumericKeys = keys.every(k => !isNaN(k) && k.trim() !== '');
                                        if (opt.value !== null && opt.value !== undefined) {
                                            if (hasNumericKeys) {
                                                opt.value = Number(opt.value);
                                            } else {
                                                opt.value = String(opt.value);
                                            }
                                        }
                                    }
                                });
                            }
                        });
                    }
                    this.gatewaysData = rawData;
                    if (showOverlay) {
                        this.loading.isActive = false;
                    }
                })
                .catch((err) => {
                    if (showOverlay) {
                        this.loading.isActive = false;
                    }
                });
        },
        refreshFromServer: function () {
            if (this.isRefreshingView) {
                return;
            }
            this.isRefreshingView = true;
            this.onUpdateActive = true;
            this.fetchData(false).then(() => {
                alertService.info(this.$t('button.refresh'));
                this.isRefreshingView = false;
                this.onUpdateActive = false;
            }).catch(() => {
                this.isRefreshingView = false;
                this.onUpdateActive = false;
            });
        },
        getSelectOptions: function (option) {
            if (!option.activities) return [];
            let activitiesObj = typeof option.activities === 'string' ? JSON.parse(option.activities) : option.activities;
            return Object.entries(activitiesObj).map(([key, value]) => {
                const isNumeric = !isNaN(key) && key.trim() !== '';
                return {
                    id: isNumeric ? Number(key) : key,
                    name: this.$t("label." + value)
                };
            });
        },
        save: function (index) {
            try {
                this.isSaving = true;
                this.onUpdateActive = true;
                const form = document.getElementById("formElem" + index);
                const formDataObj = {};
                [...form.elements].filter((el) => el.tagName !== 'BUTTON').forEach((item) => {
                    formDataObj[item.name] = item.value;
                });

                this.$store.dispatch("smsGateway/save", { form: formDataObj, search: this.search }).then((res) => {
                    alertService.successFlip(res.config.method === "put" ?? 0, this.$t("menu.sms_gateway"));
                    this.fetchData(false);
                    this.errors = {};
                    this.isSaving = false;
                    this.onUpdateActive = false;
                }).catch((err) => {
                    this.errors = err.response.data.errors;
                    this.isSaving = false;
                    this.onUpdateActive = false;
                });
            } catch (err) {
                this.isSaving = false;
                this.onUpdateActive = false;
                alertService.error(err);
            }
        },
        selectActive: function (index) {
            this.selectIndex = index;
        }
    }
};
</script>